export default __webpack_public_path__ + "static/media/14.ac1686ec.webp";